import Vue from 'vue';
import App from './App.vue';
import vuetify from '../src/plugins/vuetify';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import store from './store';
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueTilt from 'vue-tilt.js'
import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
})
Vue.use(VueTilt)

Vue.config.productionTip = true;
Vue.use(VueRouter);
Vue.use(Vuex);
import titleMixin from './titleMixin';
Vue.mixin(titleMixin);
import MainPage from './components/MainPage.vue';
import Role from './components/NewRole.vue';

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '*',
            component: MainPage,
            name: 'MainPage',
            meta: { title: 'آسا سرویس' }
        },
        {
            path: '/rule',
            component: Role,
            name: 'Role',
            meta: { title: 'قوانین و مقررات آسا سرویس' }
        },
    ],
});

new Vue({
    created() {
        AOS.init()
    },
    router: router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app');
